(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  // This function now fits ALL boxes together and picks ONE shared font-size
  function fitAllTextBoxes() {
    const containers = document.querySelectorAll('.custom-wrap');
    if (!containers.length) return;

    const measurements = [];
    const spans = [];
    const originalWhiteSpaces = new Map();

    // Collect all spans + their measurement context across ALL boxes
    containers.forEach(container => {
      const box = container.closest('.info-box');
      if (!box) return;

      const spanNodes = container.querySelectorAll('span');
      if (!spanNodes.length) return;

      const widthStr = container.dataset.widths;
      const targetWidthPercents = widthStr.split(',').map(n => parseFloat(n.trim()));

      const style = window.getComputedStyle(box);
      const paddingLeft = parseFloat(style.paddingLeft) || 0;
      const paddingRight = parseFloat(style.paddingRight) || 0;
      const boxContentWidth = box.clientWidth - paddingLeft - paddingRight;

      spanNodes.forEach((span, i) => {
        const targetPercent = targetWidthPercents[i] ?? 94;

        measurements.push({
          span,
          boxContentWidth,
          targetPercent
        });

        spans.push(span);
      });
    });

    if (!measurements.length) return;

    // Temporarily force nowrap to measure natural width
    spans.forEach(span => {
      originalWhiteSpaces.set(span, span.style.whiteSpace);
      span.style.whiteSpace = 'nowrap';
    });

    let low = 6;
    let high = 80;
    let best = low;

    const test = size => {
      // Apply test size to all spans
      spans.forEach(s => s.style.fontSize = size + 'px');

      // Check if ALL spans in ALL boxes fit within their target width
      for (const m of measurements) {
        const targetWidth = m.boxContentWidth * (m.targetPercent / 100);
        const scrollWidth = m.span.scrollWidth;
        if (scrollWidth > targetWidth + 2) {
          return false;
        }
      }
      return true;
    };

    // Binary search globally across all boxes
    if (test(high)) {
      best = high;
    } else {
      for (let i = 0; i < 15; i++) {
        const mid = (low + high) / 2;
        if (test(mid)) {
          best = mid;
          low = mid;
        } else {
          high = mid;
        }
        if (high - low < 0.1) break;
      }
    }

    // Restore white-space
    spans.forEach(span => {
      span.style.whiteSpace = originalWhiteSpaces.get(span) || '';
    });

    // Use a single global multiplier (from first container if present)
    let globalMultiplier = 0.98;
    for (const container of containers) {
      const m = parseFloat(container.dataset.multiplier);
      if (!isNaN(m)) {
        globalMultiplier = m;
        break;
      }
    }

    const finalSize = (best * globalMultiplier).toFixed(2);

    // Apply the SAME final font-size to all spans everywhere
    spans.forEach(span => {
      span.style.fontSize = finalSize + 'px';
    });
  }

  // Run aggressively — catches every possible scenario
  const run = () => requestAnimationFrame(() => requestAnimationFrame(fitAllTextBoxes));

  // 1. Initial loads
  document.addEventListener('DOMContentLoaded', () => {
    run();
    setTimeout(run, 250);
    setTimeout(run, 600);
    setTimeout(run, 1200);
  });

  // 2. Window resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(run, 100);
  });

  // 3. Font loading
  if (document.fonts) {
    document.fonts.ready.then(() => {
      setTimeout(run, 100);
      setTimeout(run, 400);
    });
  }

  // 4. Observe ANY .info-box added or resized (critical for Shopify sections!)
  if (window.MutationObserver || window.ResizeObserver) {
    const observer = new MutationObserver(run);
    observer.observe(document.body, { childList: true, subtree: true });

    if (window.ResizeObserver) {
      const ro = new ResizeObserver(run);
      document.querySelectorAll('.info-box').forEach(box => ro.observe(box));
      ro.observe(document.body);
    }
  }

  // Final fallback — run every 2 seconds for first 10 seconds (catches everything)
  let safetyCount = 0;
  const safety = setInterval(() => {
    run();
    if (++safetyCount > 5) clearInterval(safety);
  }, 2000);
})();

  } catch(e) { console.error(e); }
})();
})();
